export default function () {
  const script = document.createElement('script')
  script.id = 'stb_root'
  script['data-iframe'] = 'https://connect.studentbeans.com/v2/hum-nutrition/us'
  script['data-load'] = 'connect'
  script.src = 'https://cdn.studentbeans.com/third-party/all.js'

  const body = document.body
  body.appendChild(script)
}
